import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import { normal } from '../defaultSpacing';
export default {
    i18next: {
        ns: 'md-calculator'
    },
    data: function() {
        return {
            theme: '', // style
            title: '', // title
            description: '', //title The description text under
            bgType: '', // background type  img / color
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            }, // Background picture
            bgColor: 'white', // background color
            ...normal,
            payment: {
                total: 0,
                downPaymentRatio: 0,
                downPaymentValue: 0,
                loanTerm: 0,
                interestRate: 0,
                propertyTaxRate: 0,
                propertyTax: 0,
                homeInsurance: 0,
                hoaFee: 0,
                annualIncome: 0,
                otherMonthlyDebts: 0,
                debtRatio: 0
            },
            needRegister: false,
            listingDetail: null,
            leadFormTitle: '',
            nameFormat: '',
            requirePhone: true,
            calcInfo: {},
            simpleText: '',
            advancedText: '',
            refs: {},
        };
    },
    beforeMount() {
        this.getInit();
        this.getUpData();
        window.addEventListener('pageshow', this.onPageshow);
        // cms default value  calc  payment CHIME-25856
        let payment = this.payment || {};
        if (payment?.propertyTaxRate) {
            let total = this.payment.total || 0;
            let amount = ((total * payment.propertyTaxRate) / 100).toFixed(0);
            payment['propertyTax'] = amount;
        }
    },
    destroy() {
        window.removeEventListener('pageshow', this.onPageshow);
    },
    watch: {
        'payment.downPaymentRatio': {
            immediate: true,
            handler(value) {
                this.payment.downPaymentRatio = (+value).toFixed(3);
            }
        },
        'payment.interestRate': {
            immediate: true,
            handler(value) {
                this.payment.interestRate = (+value).toFixed(3);
            }
        },
        'payment.propertyTaxRate': {
            immediate: true,
            handler(value) {
                this.payment.propertyTaxRate = (+value).toFixed(3);
            }
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "pageKey": store => store.page?.pageKey
        }),
        suitableImg() {
            if (this.isMobileSize && this.bgImgOpt.mobileSrc) {
                return this.bgImgOpt.mobileSrc; 
            }
            return this.bgImgOpt.src || this.bgImgOpt.mobileSrc;
        },
        viewMore() {
            return `/mortgage-calculator?total=${this.payment.total}&interestRate=${this.payment.interestRate}&downPaymentRatio=${this.payment.downPaymentRatio}&loanTerm=${this.payment.loanTerm}&homeInsurance=${this.payment.homeInsurance}&propertyTaxRate=${this.payment.propertyTaxRate}`;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        
    },
    methods: {
        handleChangePayment({ key, value }) {
            this.payment[key] = value;
        },
        onRef(name, e) {
            this.refs[name] = e;
        },
        onPageshow(evt) {
            if (evt.persisted) {
                document.body.style.display = 'none';
                window.location.reload();
            }
        },
        getInit() {
            let search = this.pageLocation.search.slice(1);
            if (search) {
                let pairs = search.split('&');
                pairs.forEach(pair => {
                    let [key, value] = pair.split('=');
                    this.payment[key] = value;
                });
            }
        },
        getUpData() {
            const pageArr = ['affordability-calculator', 'mortgage-calculator'];
            if (pageArr.indexOf(this.pageKey) !== -1 && !this.hasSave) {
                this.axiosIns
                    .get(
                        '/api-site/place-data?fetcher=data&source=formRequired'
                    )
                    .then(res => {
                        let data = res.data || {};
                        if (typeof data === 'string') {
                            data = JSON.parse(data);
                        }
                        if (data.required !== undefined) {
                            this.requirePhone = data.required;
                        }
                    });
            }
        }
    },
    created() {
        this.listingDetail = this.listingDetail || {};
    }
};
